import { render, staticRenderFns } from "./EnviarLinkWA.vue?vue&type=template&id=163cbbbb&scoped=true"
import script from "./EnviarLinkWA.vue?vue&type=script&lang=js"
export * from "./EnviarLinkWA.vue?vue&type=script&lang=js"
import style0 from "./EnviarLinkWA.vue?vue&type=style&index=0&id=163cbbbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163cbbbb",
  null
  
)

export default component.exports